export const determinePriority = (data) => {
  if (data?.priority) return data?.priority;
  else {
    if (data?.component === "Toast" || data?.component === "Modal") {
      return 4;
    } else return 1;
  }
};
